import path = require("path");
import dayjs from 'dayjs';
import { IFileApproval } from "../../../_v2/components/Panels/AutomationPanel/AutomationPanel";

export const searchHitToApprovalFile = (hit: any): IFileApproval => {
  const newFile: IFileApproval = {
    itemId: hit.itemid,
    driveId: hit.driveid,
    fileType: path.extname(hit.name),
    modifiedBy: hit.modifiedby ? hit.modifiedby : hit['modified by'],
    name: hit.name,
    serverRelativePath: hit["serverrelativepath"],
    lastModifiedDateTime: hit.modifiedvalue ? hit.modifiedvalue : dayjs.unix(hit.modified).format("L"),
    contentTypeId: hit.contenttypeid
  }

  if (hit.privacysensitive) {
    if (hit.privacysensitive === 'True') {
      return {
        ...newFile,
        pii: {
          piiDetected: true,
          pii: hit.privacysensitivedata
        }
      };

    } else {
      return {
        ...newFile,
        pii: {
          piiDetected: false,
          pii: hit.privacysensitivedata
        }
      };
    }
  }
  return newFile;
}
